// extracted by mini-css-extract-plugin
export default {"container":"beta-closing_container__RcnfA","header":"beta-closing_header__1bLCo","body":"beta-closing_body__251y8","footer":"beta-closing_footer__b21zz"};